import NotificationSettingList from '@components/NotificationSettingList'
import Page from '@components/Page/Page'
import { SettingKey } from '@models/Setting'
import { useAppDispatch } from '@store/hooks'
import { getSettings } from '@store/SettingReducer'
import { Permission } from '@utils/permissions'
import { useEffect } from 'react'
import { membershipNotificationItems } from './membershipNotificationItems'

const MembershipNotificationsPage = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(getSettings([SettingKey.MEMBERSHIP_NOSHOW_NOTIFICATION_ENABLED]))
  }, [])

  return (
    <Page permissions={Permission.manageSettingsMembershipSettings}>
      <NotificationSettingList
        items={membershipNotificationItems}
        title="Membership notifications"
      />
    </Page>
  )
}

export default MembershipNotificationsPage
